import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {compose } from 'recompose'
import * as routes from '../../constants/routes';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
import Paper from '@material-ui/core/Paper';
//import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import Contacts from '@material-ui/icons/Contacts';
import { fetchAdminCanidateList } from '../../actions/adminCanidates'
import { styles } from './stylesAdminCanidateList'
import {CURRENT_OPEN_EVENT} from '../../constants/actionTypes'
import Headline from '../../Container/Headlines/PageHeadline'
import Grid from '@material-ui/core/Grid'
import {defaultGridSettings} from '../../js/settings/grid'
import CounterBoard from '../../Container/Content/CounterBoard/CounterBoard'
const arraySort = require('array-sort');


class AdminCanidateList extends Component {

   async componentDidMount() {
        const {onFetchAdminCanidateList } = this.props
       await onFetchAdminCanidateList()

    }
    toggleView = (canidateEvent) => {
        const { history, onOpenAdminCanidateDetails } = this.props
        onOpenAdminCanidateDetails(canidateEvent)
        history.push(routes.ADMINCANIDATEDETAILS)
    }

    checkHeadlineSubtext = () => {
        if(this.props.canidateEvents.length===0) {
            return 'Keine Bewerbungen vorahnden'
        } else {
            return
        }
    }

    sortedList = () => {
        const sortedList = arraySort(this.props.canidateEvents, 'event.date')
        return sortedList
    }
    // count all canidates applications to evetns
    countCanidates = () => {
        let counter = 0
        this.props.canidateEvents.map(event =>{
            return counter = counter + Object.keys(event.canidates).length
        })
        return counter

    }

    // count events with Canidates
    canidatesCounter = () => {
        const countEvents = this.props.canidateEvents.length
        const countCanidates = this.countCanidates()
        if(countEvents!==0) {
            const counterData = [
                {
                    lable: 'Hilfegesuche mit Angeboten',
                    value: countEvents
                },
                {
                    lable: 'Helferangebote',
                    value: countCanidates,
                    
                }
            ]
            return counterData
        } else {
            return null
        }
    }


    render () {
        const { classes } = this.props
        const headline = 'Hilfevermittlung'
       

        return (
            
            <div className={classes.root}>
                <Headline headline={headline} subtext={this.checkHeadlineSubtext()}/>
                <CounterBoard data={this.canidatesCounter()}/>
                <Grid container {...defaultGridSettings.container} >
                   

                        {this.sortedList().map((data) => {
                            
                            const {event, canidates, requester} = data
                            const countCanidates = Object.keys(canidates).length
                        
                            return (
                                <Grid key={event.id} item {...defaultGridSettings.item} >
                                <Paper 
                                    className={classes.paper}
                                    onClick={()=>this.toggleView(data)}
                                    >
                                    <div className={classes.header}>
                                        <Typography color='inherit' variant='subheading'>
                                            <div className={classes.requester.name}>{requester.name}</div>
                                        </Typography>
                                    </div>
                                    <div className={classes.body}>
                                        <Typography variant='body2'>
                                            <div className={classes.row}>sucht für {event.task} </div>
                                            <div className={classes.row}>in {event.ort}</div>
                                        </Typography>
                                    
                                        <Typography variant='body2'>
                                            {event.timeRange==='onData'
                                                        ? <span style={styles.red}>An einem bestimmten Datum</span>
                                                        : <span>Nach Vereinbarung bis zum: </span>
                                            }
                                            <span>{moment(event.data).format('dddd')+' '+ moment(event.date).format('L')}</span>
                                        </Typography>
                                    </div>
                                    <div className={classes.paperFooter}>
                                    
                                            <div className={classes.timeLeft }>Läuft ab in {moment(event.date, "YYYY-MM-DD").fromNow()}</div>
                                    
                                        <div style={{display: 'inline-block'}}>
                                            <Badge badgeContent={countCanidates} color="primary">
                                                <Contacts color='primary'/>
                                            </Badge>
                                        </div>
                                    </div>
                                </Paper>
                                </Grid>
                            )
                        })}
                        
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    canidateEvents: state.adminCanidateState.canidateList,
    requester: state.adminCanidateState.requester,
    currentOpenEvent: state.adminCanidateState.currentOpenEvent.data

})

const mapDispatchToProps = (dispatch) =>({
    onFetchAdminCanidateList: ()=>fetchAdminCanidateList(),
    onOpenAdminCanidateDetails: (payload)=>dispatch({type: CURRENT_OPEN_EVENT, payload})
})

    
    AdminCanidateList.propTypes = {
        classes: PropTypes.object.isRequired,
      };
    
    export default compose(
        connect(mapStateToProps, mapDispatchToProps),
        withStyles(styles),
        withRouter,
    )(AdminCanidateList)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminCanidateList.js